import React from 'react';
import { Container } from 'react-bootstrap';
import AccountCreationForm from '../auth/OrganizationForm';

const OrganizationSetupPage: React.FC = () => {
  return (
    <Container>
      <AccountCreationForm />
    </Container>
  );
};

export default OrganizationSetupPage; 